// React Navigation Web Compatibility
// This handles the "require is not defined" error in React Navigation's useFrameSize.js
if (typeof window !== 'undefined' && typeof window.require === 'undefined') {
  // @ts-ignore
  window.require = function requirePolyfill(moduleId: string) {
    console.warn(`Module ${moduleId} was required using CommonJS in the browser environment.`);
    
    // Handle specific modules that require special treatment
    if (moduleId === 'react-native-safe-area-context') {
      return {
        SafeAreaInsetsContext: {
          Consumer: ({ children }: any) => children({ top: 0, right: 0, bottom: 0, left: 0 }),
        },
      };
    }
    
    // For useFrameSize.js in @react-navigation/elements
    if (moduleId === 'react-native') {
      return {
        Dimensions: {
          get: (dim: string) => {
            if (dim === 'window') {
              return {
                width: window.innerWidth,
                height: window.innerHeight,
              };
            }
            return { width: 0, height: 0 };
          },
        },
        Platform: {
          OS: 'web',
        },
      };
    }
    
    return {};
  };
}

import { registerRootComponent } from 'expo';
import App from './App';

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
